import { Message, MessageBox, Loading } from "element-ui";
import util from "@/libs/util.js";
import router from "@/router";
import { AccountLogin } from "@api/sys.login";
import { adminLogin } from "@api/api";
import store from "@/store";

function setSha(num) {
  let sha256 = require("js-sha256").sha256; //这里用的是require方法，所以没用import
  return sha256(num); //要加密的密码
}
function randomn(n) {
  let res = "";
  for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) {}
  return res.substr(0, n);
}

function formatDate(date, fmt = "yyyy-MM-dd") {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

const padLeftZero = (str) => {
  return ("00" + str).substr(str.length);
};

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({ dispatch }, { username = "", password = "" } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        let salt = randomn(6);

        const data = {
          account: username,
          encryption: setSha(password + salt),
          salt: salt,
          clientLoginTime: formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
          clientTimeZone: new Date().toString().slice(new Date().toString().match(/[0-9]+:[0-9]+:[0-9]+/).index + 9, -1) + ")",
        };
        let loading = Loading.service({
          lock: true,
          text: "login...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        adminLogin(data)
          .then(async (res) => {
            loading.close();
            // console.log(res)
            // 设置 cookie 一定要存 uuid 和 token 两个 cookie
            // 整个系统依赖这两个数据进行校验和存储
            // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
            // token 代表用户当前登录状态 建议在网络请求中携带 token
            // 如有必要 token 需要定时更新，默认保存一天
            console.log(res);
            if (res.code != 10000) {
              Message.error(res.msg);
              return;
            }

            // 结束
            resolve(res);
          })
          .catch((err) => {
            loading.close();
            console.log("err: ", err);
            reject(err);
          });
      });
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      async function logout() {
        // 删除cookie
        util.cookies.remove("token");
        util.cookies.remove("uuid");
        // 清空 vuex 用户信息
        await dispatch("d2admin/user/set", {}, { root: true });
        // 清除菜单权限信息
        store.commit("d2admin/router/setMenuList", []);
        // 跳转路由
        router.push({
          name: "login",
        });
      }
      // 判断是否需要确认
      if (confirm) {
        commit("d2admin/gray/set", true, { root: true });
        MessageBox.confirm("Logout of the current account? The opened tabs and user settings will be saved.", "Confirm operation", {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {
            commit("d2admin/gray/set", false, { root: true });
            logout();
          })
          .catch(() => {
            commit("d2admin/gray/set", false, { root: true });
            Message({
              message: "Give up logging out user",
            });
          });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load({ dispatch }) {
      return new Promise(async (resolve) => {
        // DB -> store 加载用户名
        await dispatch("d2admin/user/load", null, { root: true });
        // DB -> store 加载主题
        await dispatch("d2admin/theme/load", null, { root: true });
        // DB -> store 加载页面过渡效果设置
        await dispatch("d2admin/transition/load", null, { root: true });
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch("d2admin/page/openedLoad", null, { root: true });
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch("d2admin/menu/asideCollapseLoad", null, { root: true });
        // DB -> store 持久化数据加载全局尺寸
        await dispatch("d2admin/size/load", null, { root: true });
        // end
        resolve();
      });
    },
  },
};
